import { faqApi } from '@/shared/api/faq';

const boardQueryKey = 'faq';

export const faqPagesQuery = () => ({
  queryKey: [boardQueryKey, 'pages'],
  queryFn: () => {
    return faqApi.get();
  },
});
